<template>
  <div class="px-10">
    <v-card flat class="mx-auto" width="80%">
      <v-card-title> Sign in </v-card-title>
      <v-card-text>
        <v-form ref="loginForm" @submit.prevent="login">
          <v-text-field
            v-model="formData.email"
            outlined
            dense
            label="Email Address"
            append-icon="email"
            :rules="[rules.email.required, rules.email.value]"
          ></v-text-field>
          <v-text-field
            v-model="formData.password"
            outlined
            dense
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            :rules="[rules.password.required, rules.password.min]"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            label="Password"
            @click:append="showPassword = !showPassword"
          ></v-text-field>
          <div>
            <router-link to="/auth/reset"
              ><small>Forgot password?</small></router-link
            >
          </div>
          <v-btn
            class="mt-2 text-capitalize"
            color="primary"
            block
            type="submit"
          >
            <div>Login</div>
            <v-icon class="mx-2">login</v-icon>
          </v-btn>
        </v-form>
        <div class="mt-4">
          <div>Dont have an account ?</div>
          <v-btn
            class="text-capitalize"
            link
            color="orange darken-2"
            :to="{ name: 'Credentials' }"
            outlined
            block
          >
            Activate
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Login",
  data: () => ({
    formData: {
      email: "",
      password: "",
      device_name: "apollo",
    },
    showPassword: false,
    rules: {
      password: {
        required: (value) => !!value || "Password is Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      email: {
        required: (value) => !!value || "Email is Required.",
        value: (value) => /.+@.+/.test(value) || "E-mail must be valid",
      },
    },
  }),
  computed: {
    ...mapState({
      loading: function (state) {
        return state.loader.loading;
      },
    }),
  },
  methods: {
    ...mapActions({
      login: function (dispatch, event) {
        /** validate form */
        const { password, email } = this.formData;
        if (
          password.length === 0 ||
          password.length < 8 ||
          email.length === 0 ||
          !/.+@.+/.test(email)
        ) {
          this.$refs.loginForm.validate();
        } else {
          dispatch("auth/login", this.formData);
          // this.formData.email = this.formData.password = ''
          event.target.reset();
        }
      },
    }),
  },
};
</script>
